// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1G1cP","title":"Info_title__C6fEZ","selects":"Info_selects__1qHPt","requiredAsterisk":"Info_requiredAsterisk__MWCjW"};